import Stack from '@mui/material/Stack'
import { useState } from 'react'
import VisaIcon from '../../assets/icons/svg/VisaIcon.svg?react'
import MastercardIcon from '../../assets/icons/svg/MastercardIcon.svg?react'
import JcbIcon from '../../assets/icons/svg/JCBIcon.svg?react'
import AmericanExpressIcon from '../../assets/icons/svg/AmericanExpressIconCard.svg?react'
import { CreditCardHelper as creditCardValidator } from '@repo/unicity'
import InputBox from '../forms/inputbox/InputBox'
import { creditCardState } from '../store/creditCard'
import { useSetAtom } from 'jotai'

const CreditCardNumber = ({ label, name, disabled }: { label: string; name: string; disabled: boolean }) => {
    const [cardNumberFormatted, setCardNumberFormatted] = useState('')
    const [creditCardType, setCreditCardType] = useState<string | null>(null)
    const setCreditCard = useSetAtom(creditCardState)

    const handleChange = (value: string) => {
        if (value.length > 19) {
            return
        }

        const cardType = creditCardValidator.checkCardType(value?.toString().replace(/\s/g, '') as string, false)

        setCreditCardType(cardType)

        let formattedNumber = ''
        let ccNumber = value.replace(/\D/g, '').slice(0, 16)

        const isAmex = /^37|^34/.test(ccNumber)
        if (isAmex) {
            ccNumber = ccNumber.slice(0, 15)
            formattedNumber = [ccNumber.substring(0, 4), ccNumber.substring(4, 10), ccNumber.substring(10, 15)].join(' ').trim()
        } else {
            formattedNumber = ccNumber.replace(/(\d{4})/g, '$1 ').trim()
        }

        setCardNumberFormatted(formattedNumber)
        setCreditCard(prev => ({
            ...prev,
            creditCardNumber: formattedNumber
        }))
    }

    const renderCreditCardType = () => {
        if (creditCardType === 'visa') {
            return <VisaIcon />
        } else if (creditCardType === 'mastercard') {
            return <MastercardIcon />
        } else if (creditCardType === 'jcb') {
            return <JcbIcon />
        } else if (creditCardType === 'american-express') {
            return <AmericanExpressIcon />
        }

        return null
    }

    return (
        <Stack direction={'column'} width={'100%'}>
            <InputBox
                type="tel"
                label={label}
                name={name}
                value={cardNumberFormatted}
                onChange={(value: string) => {
                    handleChange(value)
                }}
                endAdornment={
                    <Stack position={'absolute'} right={16} top={16}>
                        {renderCreditCardType()}
                    </Stack>
                }
                disabled={disabled}
            />
        </Stack>
    )
}

export default CreditCardNumber
